import { render, staticRenderFns } from "./HighlightedPrizeFramePicture.vue?vue&type=template&id=74b88848&scoped=true&"
import script from "./HighlightedPrizeFramePicture.vue?vue&type=script&lang=js&"
export * from "./HighlightedPrizeFramePicture.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedPrizeFramePicture.vue?vue&type=style&index=0&id=74b88848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b88848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b88848')) {
      api.createRecord('74b88848', component.options)
    } else {
      api.reload('74b88848', component.options)
    }
    module.hot.accept("./HighlightedPrizeFramePicture.vue?vue&type=template&id=74b88848&scoped=true&", function () {
      api.rerender('74b88848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/HighlightedPrizeFramePicture.vue"
export default component.exports